import { render, staticRenderFns } from "./RegistroInterfonia.vue?vue&type=template&id=75c18ae6&"
import script from "./RegistroInterfonia.vue?vue&type=script&lang=js&"
export * from "./RegistroInterfonia.vue?vue&type=script&lang=js&"
import style0 from "./RegistroInterfonia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VContainer,VIcon,VProgressLinear})
